/** Tracks file/camera picker (gallery or in-app getUserMedia) so deploy reload defers until the user finishes. */

export const FILE_PICKER_GRACE_MS = 15_000;

let openCount = 0;
let lastClosedAt = 0;

export function beginFilePickerSession() {
  openCount += 1;
}

export function endFilePickerSession() {
  openCount = Math.max(0, openCount - 1);
  if (openCount === 0) {
    lastClosedAt = Date.now();
  }
}

export function isFilePickerSessionActive() {
  return openCount > 0;
}

export function isWithinFilePickerGracePeriod() {
  return openCount > 0 || Date.now() - lastClosedAt < FILE_PICKER_GRACE_MS;
}
